// The list API is paginated. A board must include every matching task, not
// just the first page, while retaining the exact same scope and filters.
export async function loadKanbanTasks(fetchPage, request, isActive = () => true) {
  const first = await fetchPage({ ...request, offset: 0, limit: 50 })
  const items = [...first.items]
  for (let offset = first.items.length; offset < first.total;) {
    if (!isActive()) return null
    const page = await fetchPage({ ...request, offset, limit: 50, include_counts: false, include_stages: false })
    if (!page.items.length) break
    items.push(...page.items)
    offset += page.items.length
  }
  if (!isActive()) return null
  return { ...first, items: [...new Map(items.map(task => [`${task.source || 'project'}:${task.id}`, task])).values()] }
}

export function groupTaskProjects(projects) {
  return [
    ['ativo', 'Ativos'], ['pausado', 'Pausados'], ['concluido', 'Concluídos'],
    ['arquivado', 'Arquivadas'], ['deleted', 'Excluídos'],
  ].map(([id, label]) => ({ id, label, projects: projects.filter(project =>
    (project.is_delete ? 'deleted' : project.status || 'ativo') === id
  ).sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR')) })).filter(group => group.projects.length)
}

export function projectTaskView(project, currentView) {
  if (project?.is_delete) return 'deleted'
  if (project?.status === 'arquivado') return 'archived'
  if (project?.status === 'concluido') return 'completed'
  return ['archived', 'deleted'].includes(currentView) ? 'all' : currentView
}

export function groupKanbanTasks(stages, tasks) {
  const columns = stages.filter(stage => stage.id != null).map(stage => ({ ...stage, tasks: [] }))
  const byId = new Map(columns.map(column => [column.id, column]))
  const unassigned = { id: null, nome: 'Sem etapa', tasks: [] }
  for (const task of tasks) (byId.get(task.stage_id) || unassigned).tasks.push(task)
  if (unassigned.tasks.length || !columns.length) columns.push(unassigned)
  return columns
}
